module.exports = __webpack_public_path__ + "img/btn_publish.1e62a7b8.png";